import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum EmployeeCountIds {
  ONE_TO_TEN = 1,
  ELEVEN_TO_TWENTY = 2,
  TWENTY_ONE_TO_FIFTY = 3,
  FIFTY_ONE_TO_ONE_HUNDRED = 4,
  ONE_HUNRED_ONE_TO_TWO_FIFTY = 5,
  TWO_FIFTY_ONE_TO_FIVE_HUNDRED = 6,
  FIVE_HUNDRED_ONE_TO_ONE_THOUSAND = 7,
  ONE_THOUSAND_ONE_TO_FIVE_THOUSAND = 8,
  FIVE_THOUSAND_ONE_TO_TEN_THOUSAND = 9,
  TEN_THOUSAND_UP = 10,
}

export function getEmployeeCounts(): ISelectItem[] {
  return [
    { id: EmployeeCountIds.ONE_TO_TEN, label: '1-10' },
    { id: EmployeeCountIds.ELEVEN_TO_TWENTY, label: '11-20' },
    { id: EmployeeCountIds.TWENTY_ONE_TO_FIFTY, label: '21-50' },
    { id: EmployeeCountIds.FIFTY_ONE_TO_ONE_HUNDRED, label: '51-100' },
    { id: EmployeeCountIds.ONE_HUNRED_ONE_TO_TWO_FIFTY, label: '101-250' },
    { id: EmployeeCountIds.TWO_FIFTY_ONE_TO_FIVE_HUNDRED, label: '250-500' },
    {
      id: EmployeeCountIds.FIVE_HUNDRED_ONE_TO_ONE_THOUSAND,
      label: '501-1,000',
    },
    {
      id: EmployeeCountIds.ONE_THOUSAND_ONE_TO_FIVE_THOUSAND,
      label: '1,001-5,000',
    },
    {
      id: EmployeeCountIds.FIVE_THOUSAND_ONE_TO_TEN_THOUSAND,
      label: '5,001-10,000',
    },
    {
      id: EmployeeCountIds.TEN_THOUSAND_UP,
      label: '10,000+',
    },
  ]
}

export const getEmployeeCountByLabel = getItemByLabelFactory(getEmployeeCounts)
export const getEmployeeCountById = getItemByIdFactory(getEmployeeCounts)
